export const esViewKitchen = {
  navbarButton: "Ver información pública",
  pickBusinessDaysButton: "Elegir días de trabajo",
  pickBusinessDaysText:
    "Elige los días que podrás o no trabajar. También podrás personalizar horarios.",
  kitchenInfo: "Los datos mostrados arriba serán compartidos con tus clientes.",
  kitchenInfoNote: "Ojo, no está relacionado con tu información personal.",
};
